import { useState } from 'react'
import { LogOut, Settings } from 'lucide-react'
import type { Actor } from '../lib/types'
import { Link } from '../lib/router'
import { Avatar, Button, Modal } from '../ds'
import { useProjectNav, ProjectTabsBar } from '../lib/projectNav'
import { ProfileSettingsModal } from './ProfileSettingsModal'

export function Topbar({
  actor,
  onLogout,
  onActorChange
}: {
  actor: Actor
  onLogout: () => void
  onActorChange: (actor: Actor) => void
}) {
  const [confirmLogout, setConfirmLogout] = useState(false)
  const [showSettings, setShowSettings] = useState(false)
  const { nav } = useProjectNav()

  function logout() {
    setConfirmLogout(false)
    onLogout()
  }

  return (
    <>
      <header className="topbar">
        <Link href="/" className="topbar-brand">
          <span>MENTIONS</span>
          <span className="topbar-beta">beta</span>
        </Link>
        {nav ? <ProjectTabsBar activeTab={nav.activeTab} onSelect={nav.onSelect} /> : null}
        <span className="topbar-spacer" />
        <span className="topbar-email">{actor.email}</span>
        <Avatar email={actor.email} size={26} />
        <button
          className="icon-btn"
          onClick={() => setShowSettings(true)}
          title="Настройки"
          aria-label="Настройки"
        >
          <Settings size={16} />
        </button>
        <button className="icon-btn" onClick={() => setConfirmLogout(true)} title="Выйти" aria-label="Выйти">
          <LogOut size={16} />
        </button>
      </header>
      {showSettings && (
        <ProfileSettingsModal actor={actor} onClose={() => setShowSettings(false)} onActorChange={onActorChange} />
      )}
      {confirmLogout && (
        <Modal title="Выйти из аккаунта?" onClose={() => setConfirmLogout(false)} className="confirm-modal">
          <div className="stack">
            <p className="muted" style={{ margin: 0 }}>
              Вы вошли как {actor.email}. Для продолжения работы потребуется снова получить код на email.
            </p>
            <div className="row spread">
              <Button variant="secondary" onClick={() => setConfirmLogout(false)}>
                Остаться
              </Button>
              <Button variant="danger" onClick={logout}>
                <LogOut size={14} /> Выйти
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}
